import { DemoMap } from 'features/maps/types'
import { openDemoMapActionDefinition } from 'features/maps/state/mapsSlice'
import useOnboardingChecklist, { OnboardingAction } from 'features/onboarding-checklist/utils/useOnboardingChecklist'
import { useReduxAction } from 'app/state/action'
import { demoMapDuplicatedEventRequest } from 'features/metrics/state/metricsSlice'
import { useAppDispatch } from 'app/state'
import { openNewWindow } from 'features/common/utils/navigationUtils'
import { BuilderPaths } from 'features/builder/paths'

function useDemoMaps() {
  const dispatch = useAppDispatch()
  const { completeOnboardingChecklist } = useOnboardingChecklist()
  const openDemoMapAction = useReduxAction(openDemoMapActionDefinition)
  const openDemoMap = (map: DemoMap) => {
    if (map.id) {
      if (map.exists) {
        openNewWindow(BuilderPaths.EditMap(map.id))
      } else {
        openDemoMapAction.invoke({ id: map.id, url: map.templateUrl })
        dispatch(demoMapDuplicatedEventRequest({ item: map.id }))
        completeOnboardingChecklist(OnboardingAction.CheckDemoMap)
      }
    }
  }

  return { openDemoMap, openDemoMapAction }
}

export default useDemoMaps
